import { connect } from 'react-redux';
import BABusinessListing from "./List";
import { bindActionCreators } from 'redux';
import {businessListing} from "../../../services/redux/brandActivtion/sitesListing/action";
import {fetchZones, getListFilterData} from "../../../services/redux/sales/preSaleListing/action";

const mapStateToProps = state => ({
    businessList: state.baSiteListingReducer.businessListing,
    getFetchZones: state.preSalesListReducer.getFetchZones,
    filterDropdownList: state.preSalesListReducer.filterDropdownList,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    businessListing,
    getListFilterData,
    fetchZones
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(BABusinessListing);
